export default __webpack_public_path__ + "static/media/slider-image4.88a16924.jpg";